import * as Slot from '@/ui/primitives/slot'
import type { TextRef } from '@/ui/primitives/types'
import { cn } from '@/ui/utils'
import { forwardRef } from 'react'
import { Text as RNText } from 'react-native'
import { headerStyles } from './header.styles'
import type { HeaderProps } from './header.types'

const Header = forwardRef<TextRef, HeaderProps>(
	({ className, asChild = false, variant = 'h2', tone = 'ink', ...props }, ref) => {
		const Component = asChild ? Slot.Text : RNText

		return (
			<Component
				maxFontSizeMultiplier={1.4}
				role="heading"
				className={cn(headerStyles({ variant, tone }), className)}
				ref={ref}
				{...props}
			/>
		)
	}
)

Header.displayName = 'Header'

export { Header }
